import { useRef, useState, useMemo } from "react";
import { LoaderBoxCircular } from "../Components/LoaderBox";
import { Box, Container, TextField, Grid, Divider, IconButton, Typography, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Paper } from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { AddCircleTwoTone, Delete } from "@mui/icons-material";
import { DialogAlert } from "../Components/DialogAlert";
import { instance } from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { UPSE2DetalleGeneral } from "../Components/UPSE2DetalleGeneral";
import { InstruccionesModal } from "../Components/InstruccionesModal";

const CUATRIMESTRES_ORDENADOS = ["Primer", "Segundo", "Tercero"];

const MAPA_CUATRIMESTRES = {
  "Enero": "Primer", "Febrero": "Primer", "Marzo": "Primer", "Abril": "Primer",
  "Mayo": "Segundo", "Junio": "Segundo", "Julio": "Segundo", "Agosto": "Segundo",
  "Septiembre": "Tercero", "Octubre": "Tercero", "Noviembre": "Tercero", "Diciembre": "Tercero",
};

// --- Subcomponentes ---

function DatosGenerales({ lugarPresentacion, setLugarPresentacion, anio, setAnio, techo, handleChangeTecho, responsable, encargado, setEncargado, tipoPlanificacion, handleChangeTipoPlanificacion, habilitarRadio, habilitarDetalle, handleContinuar }) {
  return (
    <>
      <Grid item xs={12} sm={12}>
        <h3 style={{ textAlign: 'center', margin: 0 }}>Datos generales</h3>
      </Grid>

      <Grid item xs={12} sm={6}>
        <p>Lugar de presentación</p>
        <DropDownList
          required
          title="Seleccione lugar"
          endpoint={"/localidad/listLocalidadesv2"}
          selectedItem={lugarPresentacion}
          setSelectedItem={setLugarPresentacion}
        />
      </Grid>

      <Grid item xs={12} sm={3} marginTop={4}>
        <TextField
          required
          id="anio"
          label="Año de la meta"
          name="anio"
          type="number"
          fullWidth
          value={anio}
          onChange={(e) => setAnio(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} sm={3} marginTop={4}>
        <TextField
          id="techo"
          label="Techo presupuestario"
          name="techo"
          type="text"
          fullWidth
          value={techo}
          onChange={handleChangeTecho}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} sm={6} marginTop={2}>
        <TextField
          required
          id="direccion"
          label="Nombre de dirección, programa o unidad"
          name="direccion"
          type="text"
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={6} marginTop={1}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="responsable"
          label="Responsable"
          name="responsable"
          disabled
          value={responsable.Nombre}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <p>Visto bueno</p>
        <DropDownList
          required
          title="Seleccione encargado"
          endpoint={"/users/listActive"}
          selectedItem={encargado}
          setSelectedItem={setEncargado}
        />
      </Grid>

      <Grid item sm={6}>
        <FormControl>
          <FormLabel>Tipo de programa</FormLabel>
          <RadioGroup
            row
            name="row-radio-buttons-group"
            value={tipoPlanificacion}
            onChange={handleChangeTipoPlanificacion}
          >
            <FormControlLabel value="personas" control={<Radio />} label="Personas" disabled={!habilitarRadio} />
            <FormControlLabel value="eventos" control={<Radio />} label="Eventos" disabled={!habilitarRadio} />
            <FormControlLabel value="documentos" control={<Radio />} label="Documentos" disabled={!habilitarRadio} />
            <FormControlLabel value="semillas" control={<Radio />} label="Semillas" disabled={!habilitarRadio} />
          </RadioGroup>
        </FormControl>
      </Grid>

      {!habilitarDetalle &&
        <>
          <Grid xs={12} item sm={4}></Grid>
          <Grid item sm={4} mt={2}>
            <Button fullWidth variant="contained" onClick={handleContinuar}>Confirmar y continuar</Button>
          </Grid>
          <Grid item sm={4}></Grid>
        </>
      }
    </>
  );
}

function SelectorProductos({ producto, setProducto, subProducto, setSubProducto, esSemillas, categoria, setCategoria, unidad, setUnidad, tipoCultivo, setTipoCultivo, cultivar, setCultivar, onAgregar }) {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <p>Producto</p>
        <DropDownList
          required
          title="Catálogo"
          endpoint={`/catalogo/listActive?esSemilla=${esSemillas ? 1 : 0}`}
          selectedItem={producto}
          setSelectedItem={setProducto}
        />
      </Grid>

      <Grid item xs={12} sm={5}>
        <p>Subproducto</p>
        <DropDownList
          required
          title="Producto"
          endpoint={
            producto.Id !== ""
              ? `/producto/listActiveV2/${producto.Id}?esSemilla=${esSemillas ? 1 : 0}`
              : undefined
          }
          selectedItem={subProducto}
          setSelectedItem={setSubProducto}
          disabled={producto.Id === ""}
          hierarchyUpdated={producto}
        />
      </Grid>

      {esSemillas &&
        <>
          <Grid item xs={12} sm={6}>
            <p>Cultivo</p>
            <DropDownList
              required
              title="Cultivo"
              endpoint={
                subProducto.Id !== ""
                  ? `/cultivo/tipos/byProducto/${subProducto.Id}`
                  : undefined
              }
              selectedItem={tipoCultivo}
              setSelectedItem={setTipoCultivo}
              disabled={subProducto.Id === ""}
              hierarchyUpdated={subProducto}
            />
          </Grid>

          <Grid item xs={12} sm={5}>
            <p>Cultivar</p>
            <DropDownList
              required
              title="Cultivar"
              endpoint={
                tipoCultivo.Id !== "" && subProducto.Id !== ""
                  ? `/cultivo/cultivar/byTipoCultivo/${tipoCultivo.Id}/${subProducto.Id}`
                  : undefined
              }
              selectedItem={cultivar}
              setSelectedItem={setCultivar}
              disabled={tipoCultivo.Id === ""}
              hierarchyUpdated={tipoCultivo}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <p>Categoria de unidad de medida</p>
            <DropDownList
              required
              title="Categoría"
              endpoint={"/categoria/listActive"}
              selectedItem={categoria}
              setSelectedItem={setCategoria}
            />
          </Grid>

          <Grid item xs={12} sm={5}>
            <p>Unidad de medida</p>
            <DropDownList
              required
              title="Unidad"
              endpoint={
                categoria.Id !== ""
                  ? `/unidad/listActive/${categoria.Id}`
                  : undefined
              }
              selectedItem={unidad}
              setSelectedItem={setUnidad}
              disabled={categoria.Id === ""}
              hierarchyUpdated={categoria}
            />
          </Grid>
        </>
      }

      <Grid item sm={1} xs={12}>
        <p>Agregar</p>
        <IconButton aria-label="Agregar producto" onClick={onAgregar}>
          <AddCircleTwoTone color="success" fontSize="large" />
        </IconButton>
      </Grid>
    </>
  );
}

function ListaAgrupada({ productosAgrupados, tipoPlanificacion, esSemillas, onEliminar }) {
  if (esSemillas) {
    return (
      <>
        <Grid item sm={2}></Grid>
        <Grid xs={12} sm={8}>
          {Object.entries(productosAgrupados).map(([subId, subData]) => (
            <Box key={subId} sx={{ marginBottom: 4 }}>
              <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
                {subData.nombre}
              </Typography>
              {Object.entries(subData.cultivos).map(([tipoId, tipoData]) => (
                <Box key={tipoId} sx={{ ml: 2, mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                    Cultivo: {tipoData.nombre}
                  </Typography>
                  {tipoData.items.map((item) => (
                    <Box
                      key={item.secuencial}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        border: '1px solid #ccc',
                        borderRadius: 1,
                        paddingY: 1,
                        paddingX: 1,
                        marginBottom: 1,
                        marginLeft: 2,
                        boxShadow: 1,
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="body2">
                          Cultivar: {item.cultivar.Nombre} | Meta anual: {item.total}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', minWidth: 120, gap: 1 }}>
                        <IconButton aria-label="Eliminar cultivar" onClick={() => onEliminar(item.secuencial)} size="small">
                          <Delete color="error" fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          ))}
        </Grid>
        <Grid item sm={2}></Grid>
      </>
    );
  }

  return (
    <>
      <Grid item sm={2}></Grid>
      <Grid xs={12} sm={8}>
        {Object.entries(productosAgrupados).map(([categoriaId, categoriaData]) => (
          <Box key={categoriaId} sx={{ marginBottom: 4 }}>
            <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
              {categoriaData?.nombre}, {tipoPlanificacion}: {categoriaData?.items?.reduce((acc, item) => acc + item.total, 0)}
            </Typography>
            {categoriaData.items?.map((producto) => (
              <Box
                key={producto.secuencial}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  border: '1px solid #ccc',
                  borderRadius: 1,
                  paddingY: 1,
                  paddingX: 1,
                  marginBottom: 1,
                  boxShadow: 1,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body2">
                    Centro de costo: {producto.localidad.Nombre} | Meta anual: {producto.total}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', minWidth: 120, gap: 1 }}>
                  <IconButton aria-label="Eliminar producto" onClick={() => onEliminar(producto.secuencial)} size="small">
                    <Delete color="error" fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
            ))}
          </Box>
        ))}
      </Grid>
      <Grid item sm={2}></Grid>
    </>
  );
}

function SumatoriaCuatrimestres({ totalesPorCuatrimestre }) {
  const total = CUATRIMESTRES_ORDENADOS.reduce((acc, c) => acc + totalesPorCuatrimestre[c], 0);
  return (
    <Grid item xs={12} mb={2}>
      <Box sx={{ mt: 2 }}>
        <Typography variant="h6" gutterBottom>Sumatoria por cuatrimestre</Typography>
        <Grid container spacing={1}>
          {CUATRIMESTRES_ORDENADOS.map((cuatrimestre) => (
            <Grid item xs={6} sm={3} md={3} key={cuatrimestre}>
              <Paper elevation={1} sx={{ p: 1, textAlign: 'center' }}>
                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{cuatrimestre}</Typography>
                <Typography variant="body1">{totalesPorCuatrimestre[cuatrimestre]}</Typography>
              </Paper>
            </Grid>
          ))}
          <Grid item xs={6} sm={3} md={3}>
            <Paper elevation={1} sx={{ p: 1, textAlign: 'center' }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Total</Typography>
              <Typography variant="body1">{total}</Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}

// --- Componente principal ---

function UPSE2Agregar() {
  const { user } = useAuth();
  const secuencialRef = useRef(0);

  const [lugarPresentacion, setLugarPresentacion] = useState({ Id: "", Nombre: "" });
  const [encargado, setEncargado] = useState({ Id: "", Nombre: "" });
  const [anio, setAnio] = useState(new Date().getFullYear());
  const [techo, setTecho] = useState(0);
  const [responsable] = useState({ Id: user.id, Nombre: user.nombre + " " + user.apellido });
  const [producto, setProducto] = useState({ Id: "", Nombre: "" });
  const [subProducto, setSubProducto] = useState({ Id: "", Nombre: "" });
  const [categoria, setCategoria] = useState({ Id: "", Nombre: "" });
  const [unidad, setUnidad] = useState({ Id: "", Nombre: "" });
  const [tipoCultivo, setTipoCultivo] = useState({ Id: "", Nombre: "" });
  const [cultivar, setCultivar] = useState({ Id: "", Nombre: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [openFormGeneral, setOpenFormGeneral] = useState(false);

  const [tipoPlanificacion, setTipoPlanificacion] = useState('personas');
  const [habilitarDetalle, setHabilitarDetalle] = useState(false);
  const [habilitarRadio, setHabilitarRadio] = useState(true);

  const [listaProductos, setListaProductos] = useState([]);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [indexEdicion, setIndexEdicion] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/UPSE2",
    pageState: {}
  });

  const esPlanificacionSemillas = tipoPlanificacion === 'semillas';

  const productosAgrupados = useMemo(() => {
    if (esPlanificacionSemillas) {
      // Agrupar por subProducto → tipoCultivo → cultivares
      return listaProductos.reduce((acc, item) => {
        const subId = item.subProducto.Id;
        if (!acc[subId]) {
          acc[subId] = { nombre: item.subProducto.Nombre, cultivos: {} };
        }
        const tipoId = item.tipoCultivo.Id;
        if (!acc[subId].cultivos[tipoId]) {
          acc[subId].cultivos[tipoId] = { nombre: item.tipoCultivo.Nombre, items: [] };
        }
        acc[subId].cultivos[tipoId].items.push(item);
        return acc;
      }, {});
    }
    return listaProductos.reduce((acc, item) => {
      const id = item.subProducto.Id;
      if (!acc[id]) {
        acc[id] = { nombre: item.subProducto.Nombre, items: [] };
      }
      acc[id].items.push(item);
      return acc;
    }, {});
  }, [listaProductos, esPlanificacionSemillas]);

  const totalesPorCuatrimestre = useMemo(() => {
    const acumulador = {};
    CUATRIMESTRES_ORDENADOS.forEach(c => { acumulador[c] = 0; });
    listaProductos.forEach(item => {
      item.detalleCompleto.forEach(({ mes, cantidad }) => {
        const cuatri = MAPA_CUATRIMESTRES[mes];
        if (cuatri) acumulador[cuatri] += cantidad;
      });
    });
    return acumulador;
  }, [listaProductos]);

  const handleContinuar = () => {
    if (lugarPresentacion.Id === "") {
      setDialog({ title: 'Falta informacion', text: 'Debe seleccionar el lugar de presentación' });
      setOpenDialog(true);
      return;
    }
    setHabilitarRadio(false);
    setHabilitarDetalle(true);
  };

  const handleDetalleGeneral = (data) => {
    if (modoEdicion && indexEdicion !== null) {
      const copia = [...listaProductos];
      const idx = copia.findIndex(item => item.secuencial === data.secuencial);
      if (idx !== -1) {
        copia[idx] = data;
        setListaProductos(copia);
      }
    } else {
      secuencialRef.current += 1;
      data['producto'] = producto;
      data['secuencial'] = secuencialRef.current;
      if (esPlanificacionSemillas) {
        data['tipoCultivo'] = tipoCultivo;
        data['cultivar'] = cultivar;
      }
      setListaProductos(prev => [...prev, data]);
    }
    setModoEdicion(false);
    setIndexEdicion(null);
  };

  const handleEliminarGeneral = (secuencial) => {
    setListaProductos(prev => prev.filter(p => p.secuencial !== secuencial));
  };

  const handleCloseGeneral = () => {
    setOpenFormGeneral(false);
    setModoEdicion(false);
    setIndexEdicion(null);
  };

  const handleAgregarProductoGeneral = () => {
    if (subProducto.Id === "") {
      setDialog({ title: 'Falta informacion', text: 'Debe seleccionar un subproducto valido' });
      setOpenDialog(true);
      return;
    }
    if (esPlanificacionSemillas && unidad.Id === "") {
      setDialog({ title: 'Falta informacion', text: 'Debe seleccionar la unidad de medida' });
      setOpenDialog(true);
      return;
    }
    if (esPlanificacionSemillas && cultivar.Id === "") {
      setDialog({ title: 'Falta informacion', text: 'Debe seleccionar el cultivo y cultivar' });
      setOpenDialog(true);
      return;
    }
    if (esPlanificacionSemillas) {
      const existe = listaProductos.some(item => item.cultivar?.Id === cultivar.Id);
      if (existe) {
        setDialog({ title: 'Error', text: 'El cultivar seleccionado ya ha sido agregado anteriormente' });
        setOpenDialog(true);
        return;
      }
    }
    setOpenFormGeneral(true);
  };

  const enviarFormulario = (e) => {
    e.preventDefault();
    const info = e.target;
    if (listaProductos.length === 0) {
      setDialog({ title: 'Error al enviar formulario', text: 'Debe agregar detalle de productos' });
      setOpenDialog(true);
      return;
    }
    setIsLoading(true);
    let listaFinal = listaProductos;
    if (esPlanificacionSemillas) {
      // Agrupar por subProducto para el backend
      const agrupado = {};
      listaProductos.forEach(item => {
        const subId = item.subProducto.Id;
        if (!agrupado[subId]) {
          agrupado[subId] = {
            subProducto: item.subProducto,
            unidadMedida: item.unidadMedida,
            localidad: item.localidad,
            observaciones: null,
            total: 0,
            cultivares: []
          };
        }
        agrupado[subId].total += item.total;
        agrupado[subId].cultivares.push({
          cultivar: item.cultivar,
          total: item.total,
          observaciones: item.observaciones,
          detalleCompleto: item.detalleCompleto
        });
      });
      listaFinal = Object.values(agrupado);
    }
    const payload = {
      lugar: lugarPresentacion.Id,
      nombreLocalidad: lugarPresentacion.Nombre,
      anioMeta: info.anio.value,
      techo: info.techo.value,
      direccion: info.direccion.value,
      responsable: responsable.Id,
      encargado: encargado.Id,
      tipoPlanificacion,
      listaProductos: listaFinal,
    };
    instance.post('/upse2/crear', payload)
      .then(() => {
        setDialog({
          title: 'Aviso',
          text: 'Se ha creado correctamente el formulario',
          redirect: true,
          page: '/UPSE2'
        });
        setAnio(new Date().getFullYear());
        setTecho(0);
        setListaProductos([]);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.mensaje });
        }
      })
      .finally(() => {
        setIsLoading(false);
        setOpenDialog(true);
      });
  };

  const handleChangeTecho = (e) => {
    const value = e.target.value;
    if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
      setTecho(value);
    }
  };

  return (
    <Container>
      <Box sx={{ marginTop: 4, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <h2 style={{ textAlign: 'center', flex: 1, margin: 0 }}>UPSE-2 Metas físicas</h2>
        <InstruccionesModal clave="UPSE2" />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <LoaderBoxCircular isLoading={isLoading} loadingText="Registrando formulario, por favor espere...">
          <Container maxWidth="lg" sx={{ marginBottom: 5 }}>
            <Box
              sx={{
                padding: "4px",
                margin: { xs: 0, sm: 1 },
                border: { xs: "0", sm: "1px solid #000" },
              }}
              component="form"
              onSubmit={enviarFormulario}
            >
              <Grid container spacing={3} padding={1} rowSpacing={1} sx={{ alignItems: "center" }}>
                <DatosGenerales
                  lugarPresentacion={lugarPresentacion}
                  setLugarPresentacion={setLugarPresentacion}
                  anio={anio}
                  setAnio={setAnio}
                  techo={techo}
                  handleChangeTecho={handleChangeTecho}
                  responsable={responsable}
                  encargado={encargado}
                  setEncargado={setEncargado}
                  tipoPlanificacion={tipoPlanificacion}
                  handleChangeTipoPlanificacion={(e) => setTipoPlanificacion(e.target.value)}
                  habilitarRadio={habilitarRadio}
                  habilitarDetalle={habilitarDetalle}
                  handleContinuar={handleContinuar}
                />

                {habilitarDetalle &&
                  <>
                    <Grid item xs={12} sm={12} marginTop={3}>
                      <Divider variant="middle" component="aside" />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <h3 style={{ textAlign: 'center', margin: 0 }}>Detalle de {tipoPlanificacion}</h3>
                    </Grid>

                    <SelectorProductos
                      producto={producto}
                      setProducto={setProducto}
                      subProducto={subProducto}
                      setSubProducto={setSubProducto}
                      esSemillas={esPlanificacionSemillas}
                      categoria={categoria}
                      setCategoria={setCategoria}
                      unidad={unidad}
                      setUnidad={setUnidad}
                      tipoCultivo={tipoCultivo}
                      setTipoCultivo={setTipoCultivo}
                      cultivar={cultivar}
                      setCultivar={setCultivar}
                      onAgregar={handleAgregarProductoGeneral}
                    />

                    <Grid item xs={12} sm={12} marginTop={3}>
                      <Divider variant="middle" component="aside" />
                    </Grid>

                    <ListaAgrupada
                      productosAgrupados={productosAgrupados}
                      tipoPlanificacion={tipoPlanificacion}
                      esSemillas={esPlanificacionSemillas}
                      onEliminar={handleEliminarGeneral}
                    />

                    <SumatoriaCuatrimestres totalesPorCuatrimestre={totalesPorCuatrimestre} />

                    <Grid item sm={4}></Grid>
                    <Grid item xs={12} sm={4}>
                      <Button fullWidth variant="contained" type="submit">Registrar</Button>
                    </Grid>
                  </>
                }
              </Grid>
            </Box>
          </Container>
        </LoaderBoxCircular>
        <UPSE2DetalleGeneral
          open={openFormGeneral}
          onClose={handleCloseGeneral}
          onSubmit={handleDetalleGeneral}
          subProducto={subProducto}
          infoDetalle={productoSeleccionado}
        />
        <DialogAlert
          title={dialog.title}
          text={dialog.text}
          open={openDialog}
          setOpen={setOpenDialog}
          redirectOnClose={dialog.redirect}
          page={dialog.page}
          pageState={dialog.pageState}
        />
      </Box>
    </Container>
  );
}

export { UPSE2Agregar };
